import React, { Suspense, useEffect, useState } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Layout } from 'antd';
import Header from '@/components/Header';
import AppBreadcrumb from '@/components/AppBreadcrumb';
import Sider from '@/components/Sider';
import AppLoading from '@/components/AppLoading';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import HeaderMobile from '@/components/HeaderMobile';
import { UnsavedProvider } from '@/contexts/UnsavedContext';
import './index.scss';
import { useMenuItems } from '@/hooks/useMenuItems';
import { VerticalLeftOutlined, VerticalRightOutlined } from '@ant-design/icons';

function MainLayout() {
  const isMobilePlus = useMediaQuery(`(max-width: ${mediaQueryPoints.mdPlus}px)`);
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);
  const menuItems = useMenuItems();
  const [collapsed, setCollapsed] = useState(false);
  const isBreak = useMediaQuery(
    `(max-width: ${mediaQueryPoints.xl}px) and (min-width: ${mediaQueryPoints.mdPlus + 1}px)`
  );

  useEffect(() => {
    if (isBreak) setCollapsed(true);
    else setCollapsed(false);
  }, [isBreak]);

  return (
    <Layout className="">
      <UnsavedProvider>
        {!isMobilePlus && (
          <Layout.Sider
            width={250}
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              height: '100vh',
              position: isBreak ? 'fixed' : 'sticky',
              insetInlineStart: 0,
              // top: '64px',
              top: 0,
              bottom: 0,
              scrollbarWidth: 'thin',
              zIndex: 1000,
              // paddingTop: 64,
              boxShadow:
                isBreak && !collapsed
                  ? '2px 0 8px rgba(0, 0, 0, 0.15)'
                  : '2px 0 4px rgba(0, 0, 0, 0.1)',
            }}
            collapsible
            className={`layout-sider`}
            theme="light"
            breakpoint="lg"
            trigger={null}
            collapsed={collapsed}
          >
            <Sider items={menuItems} theme="light" hasLogo />
          </Layout.Sider>
        )}
        <Layout>
          <Layout.Header
            className={`flex items-center bg-white shadow-sm sticky top-0 z-[999] inset-x-0 ${isBreak ? (collapsed ? '!pl-[96px]' : '!pl-[266px]') : ''} transition-all duration-300 ease-in-out`}
          >
            {isMobilePlus ? (
              <HeaderMobile items={menuItems} />
            ) : (
              <Header collapsed={collapsed} setCollapsed={setCollapsed} />
            )}
          </Layout.Header>
          <Layout.Content
            className={`p-4 ${!isMobilePlus && !isBreak ? 'px-6' : 'px-3'} ${isBreak ? 'pl-[92px]' : ''}`}
          >
            <AppBreadcrumb />
            <Outlet />
          </Layout.Content>
          <ScrollRestoration
            getKey={(location, matches) => {
              return null;
            }}
          />
        </Layout>
      </UnsavedProvider>
    </Layout>
  );
}

export default MainLayout;
